import { io } from "socket.io-client";
import { socketUrl } from "../store/api/routes";

const SOCKET_URL = socketUrl;

export const socket = io(SOCKET_URL, {
  transports: ["websocket"], // Ensure only WebSocket is used
});
